import { KsService, useApiClient } from '@siclop/kstone-vue'
import type { EstimationScale } from '../models'

export class EstimationScaleService extends KsService {
  protected static mainUrl = '/estimation-scales'

  /**
   * Get all active estimation scales
   */
  static async getActiveScales(): Promise<EstimationScale[]> {
    const client = useApiClient()
    return await client.getAll<EstimationScale>(`${this.mainUrl}/active`)
  }

  /**
   * Get estimation scale by code
   */
  static async getByCode(code: string): Promise<EstimationScale | null> {
    const client = useApiClient()
    return await client.get<EstimationScale>(`${this.mainUrl}/code/${code}`) ?? null
  }

  /**
   * Toggle active status
   */
  static async toggleActive(id: number): Promise<EstimationScale> {
    const client = useApiClient()
    const axios = client.getAxiosInstance()
    const response = await axios.patch<EstimationScale>(`${this.mainUrl}/${id}/toggle-active`)
    return response.data
  }

  /**
   * Reorder a single estimation scale
   */
  static async reorder(scaleId: number, newOrder: number): Promise<void> {
    const client = useApiClient()
    await client.postRaw<{ newOrder: number }, void>(`${this.mainUrl}/${scaleId}/reorder`, { newOrder })
  }
}
